export default function Worker_fn() {
  return new Worker(__webpack_public_path__ + "static/js/packet.worker.0a761111.js");
}
